/*
*
*/
export const setSelectedDate = async ({ state }, date) => {
  state.dateSlider.selectedDate = date;
};
